import React from 'react'

const NotFound = () => {
	return (
		<div>404 page not found, dude!</div>
	)
}

export default NotFound